import { render, staticRenderFns } from "./IconSet.vue?vue&type=template&id=efb51b2e&"
import script from "./IconSet.vue?vue&type=script&lang=js&"
export * from "./IconSet.vue?vue&type=script&lang=js&"
import style0 from "./IconSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports